import { postMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

export const GET_TIME_SLOTS = 'GET_TIME_SLOTS';
export const GET_TIME_SLOTS_SUCCESS = 'GET_TIME_SLOTS_SUCCESS';
export const GET_TIME_SLOTS_FAILURE = 'GET_TIME_SLOTS_FAILURE';

export const fetchGetTimeSlots = () => ({ type: GET_TIME_SLOTS });
export const fetchGetTimeSlotsSuccess = (data) => ({
  type: GET_TIME_SLOTS_SUCCESS,
  payload: data,
});
export const fetchGetTimeSlotsFailure = (error) => ({
  type: GET_TIME_SLOTS_FAILURE,
  payload: error,
});

export const getTimeSlotsCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetTimeSlots(data, external));
    try {
      const requestBody = {
        provider_id: data.provider_id || '',
        services_ids: data.services_ids || [],
        for_date: data.for_date || '',
        day_of_week: data.day_of_week || '',
      };
      const response = await postMethodWithToken(url.getTimeSlots, requestBody);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetTimeSlotsSuccess(response.data));
        if (external && external.run === true) {
          external.handleFunction(response);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetTimeSlotsFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetTimeSlotsFailure(error.message));
      if (external && external.toast) {
        external.handleToastError(error.response);
      }
    }
  };
};
